import './App.css';

import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { useState, useEffect } from 'react';

const awsRegion = process.env.REACT_APP_AWS_REGION;
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId,
      allowGuestAccess: true,
    },
  },
  Liveness: {
    region: awsRegion,
  },
});

function App() {
  const [sessionId, setSessionId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get session ID from URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionIdFromUrl = urlParams.get('sessionId');
    
    if (sessionIdFromUrl) {
      setSessionId(sessionIdFromUrl);
    } else {
      // Fallback to default session ID if not provided
      setSessionId('456eb8f2-dec9-4fb7-abca-40e1dd0b763d');
    }
    
    setIsLoading(false);
  }, []);

  // Function to send message to React Native app
  const sendMessageToReactNative = (message) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    } else {
      console.log('Message to React Native:', message);
    }
  };

  const handleAnalysisComplete = () => {
    sendMessageToReactNative({
      type: 'ANALYSIS_COMPLETE',
    });
  };

  const handleError = (error) => {
    console.error('Liveness detection error:', error);
    console.error('Error details:', {
      name: error.name,
      message: error.message,
      stack: error.stack,
      code: error.code,
      state: error.state
    });
    
    setError(error.message);
    
    // Send error message to React Native app
    sendMessageToReactNative({
      type: 'ERROR',
      error: {
        name: error.name,
        message: error.message,
        code: error.code
      }
    });
  };

  if (isLoading) {
    return <div className="App">Loading liveness detector...</div>;
  }

  if (error) {
    return (
      <div className="App">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="App">
      <FaceLivenessDetector 
        sessionId={sessionId}
        onAnalysisComplete={handleAnalysisComplete}
        onError={handleError}
        region={awsRegion}
        disableStartScreen={true}
        disableInstructionScreen={true}
        disableResultScreen={false}
        disableEndScreen={true}
      />
    </div>
  );
}

export default App;
